import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ButtonModule } from '@shared/components/button/button.module';

import { DirectivesModule } from '@shared/directives/directives.module';
import { BrowserModule } from '@angular/platform-browser';

import {
  FormFieldCrudControlsModule
} from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { CustomFieldCheckboxComponent } from './custom-field-checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormlyModule,
    DirectivesModule,
    BrowserModule,
    FormFieldCrudControlsModule
  ],
  declarations: [CustomFieldCheckboxComponent],
  exports: [CustomFieldCheckboxComponent]
})
export class CustomFieldCheckboxModule { }
